import { createStore } from 'effector'
import { NavigateFunction } from 'react-router-dom'

import { setNavigate } from './event'

export const $navigate = createStore<NavigateFunction>(() => ({}))
  .on(setNavigate, (_, navigate) => navigate)
